import { render, staticRenderFns } from "./afterClassQA.vue?vue&type=template&id=2476811a&scoped=true"
import script from "./afterClassQA.vue?vue&type=script&lang=js"
export * from "./afterClassQA.vue?vue&type=script&lang=js"
import style0 from "./afterClassQA.vue?vue&type=style&index=0&id=2476811a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476811a",
  null
  
)

export default component.exports